export var ChartOptions;
(function (ChartOptions) {
    ChartOptions["Line"] = "line";
    ChartOptions["LineStacked"] = "lineStacked";
    ChartOptions["LineArea"] = "lineArea";
    ChartOptions["Bar"] = "bar";
    ChartOptions["BarStacked"] = "barStacked";
    ChartOptions["BarHorizontal"] = "barHorizontal";
    ChartOptions["BarHorizontalStacked"] = "barHorizontalStacked";
    ChartOptions["Pie"] = "pie";
    ChartOptions["Doughnut"] = "doughnut";
    ChartOptions["Bubble"] = "bubble";
})(ChartOptions || (ChartOptions = {}));
export var PointStyles;
(function (PointStyles) {
    PointStyles["Circle"] = "circle";
    PointStyles["Rectangle"] = "rect";
    PointStyles["Triangle"] = "triangle";
    PointStyles["RectangleRotated"] = "rectRot";
})(PointStyles || (PointStyles = {}));
export var Shapes;
(function (Shapes) {
    Shapes["Square"] = "square";
    Shapes["DiagonalRightLeft"] = "diagonalRightLeft";
    Shapes["Grid"] = "grid";
    Shapes["Diagonal"] = "diagonal";
    Shapes["VerticalLine"] = "verticalLine";
    Shapes["GridRightLeft"] = "gridRightLeft";
})(Shapes || (Shapes = {}));
//# sourceMappingURL=ChartTypes.js.map